import http from '../utils/http';
export const getTeamList = (data) => {
  return http.post('/app/business/home/volunteerTeamPage', data);
};

export const newsList = (data) => {
  return http.post('/app/business/home/newsList', data);
};

export const activityList = (data) => {
  return http.post('/app/business/home/activityPage', data);
};
export const teamMemberPage = (data) => {
  return http.post('/app/business/home/teamMemberPage', data);
};

export const wishList = (data) => {
  return http.post('/app/business/home/wishPage', data);
};

export const getDicts = (data) => {
  return http.get('/app/business/home/dictList');
};

export const homeData = () => {
  return http.get('/app/business/home/pcHomeData');
};

export const homeConfig = () => {
  return http.get('/app/business/home/config');
};

export const newsInfo = (params) => {
  return http.get('/app/business/home/newsInfo', { params });
};

export const wishInfo = (params) => {
  return http.get('/app/business/home/wishInfo', { params });
};

export const activityInfo = (params) => {
  return http.get('/app/business/home/activityInfo', { params });
};

export const helpList = (params) => {
  return http.get('/app/business/home/helpList', { params });
};
export const massInfo = (params) => {
  return http.get('/app/business/home/massInfo', { params });
};
export const getQRCode = (data) => {
  console.log('[API] getQRCode 调用，参数:', data);
  return http.post('/app/business/home/getQRCode', data).then(res => {
    console.log('[API] getQRCode 响应:', res);
    return res;
  }).catch(err => {
    console.error('[API] getQRCode 错误:', err);
    throw err;
  });
};
